import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function HerzlichWillkommen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="27941" id="herzlich-willkommen" ref={ref} className="bg-background py-24 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-8">
        {}
        <div className={cn("text-center mb-16 transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-4xl md:text-5xl font-default text-primary uppercase tracking-widest">
            Herzlich Willkommen
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-6 opacity-20" />
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-start">
          {}
          <div className={cn("lg:col-span-3 space-y-6 transition-all duration-1000 delay-200 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <h3 className="text-2xl font-default font-medium text-foreground mb-4">
              Klarheit in der Stille – Lösungen in Bewegung
            </h3>
            <p className="text-lg text-muted-foreground leading-[1.8] font-default"><div>Manchmal ändert das Leben Dinge, die wir so nicht wollten. Und manchmal stagnieren die Dinge, obwohl wir uns Veränderung wünschen. Beides kann uns zeitweise so sehr herausfordern, dass wir Unterstützung suchen.&nbsp;</div><div>
            </div><div>
            </div><div>
            </div><div>
            </div><div>
            </div></p>
            <p className="text-lg text-muted-foreground leading-[1.8] font-default">Als Expertin für die Interaktion von Körper und Geist begleite ich Dich dabei, Klarheit in der Stille und Lösungen in Bewegung zu finden. Dabei stelle ich Dir meine psychologische Expertise in zwei Formaten zur Verfügung: Als Senior Coach (DBVC, IOBC), wenn du Du gerade Weiterentwicklung und neue Perspektiven brauchst. Als Heilpraktikerin für Psychotherapie, wenn Du mit einer behandlungsbedürftigen Diagnose zu mir kommst. In beiden Fällen helfe ich Dir kompetent weiter, kraftvolle Schritte hin zu stimmigen Lösungen zu machen.</p>
          </div>

          {}
          <div className={cn("lg:col-span-2 flex flex-col justify-center h-full space-y-8 transition-all duration-1000 delay-400 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <div className="bg-muted/30 p-8 border-l-2 border-primary/40 rounded-r-2xl shadow-sm">
              <p className="text-foreground italic text-xl leading-relaxed font-serif">"Symptome sind Ausdrucksformen kompetenten Wissens über das, was man braucht."<br />(Gunther Schmidt)</p>
            </div>

            <div className="pt-4">
              
              <div className="mt-2">
                
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}